module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/intro-backup-mobile.7097c93a.jpg";